(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal/assets/javascripts/quickplay-modal-main.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal/assets/javascripts/quickplay-modal-main.js');
"use strict";


const {
  useState
} = React;
const {
  Currency: formatCurrency
} = svs.utils.format;
const {
  getDisplayName
} = svs.utils.products;
const {
  BOMBEN,
  MALTIPSET,
  T8,
  T8EXTRA,
  T8STRYK,
  EUROPATIPSET,
  STRYKTIPSET,
  CHALLENGE,
  POWERPLAY,
  MATCHEN,
  RACING
} = svs.utils.products.productIds;
const {
  ReactButton: Button,
  ReactIcon: Icon
} = svs.ui;
const {
  getSystemPrice
} = svs.components.lbUi;
const {
  Coupon1x2,
  CouponNumberBoard,
  CouponScore,
  CouponRacing
} = svs.components.sport.quickplayModal.coupons;
const {
  NumberSelector
} = svs.components.lbUi.numberSelector;
const logger = new svs.core.log.Logger('svs.sport.QuickplayModal');
const {
  getPixHandler
} = svs.components.sport.pixHandler;
const renderCoupon = _ref => {
  let {
    branding,
    drawData,
    productId,
    isPixMix
  } = _ref;
  switch (productId) {
    case T8:
    case T8STRYK:
    case T8EXTRA:
    case POWERPLAY:
    case EUROPATIPSET:
    case STRYKTIPSET:
    case CHALLENGE:
      return React.createElement(Coupon1x2, {
        branding: branding,
        drawData: drawData,
        isPixMix: isPixMix
      });
    case BOMBEN:
    case MATCHEN:
      return React.createElement(CouponScore, {
        branding: branding,
        drawData: drawData,
        isPixMix: isPixMix
      });
    case MALTIPSET:
      return React.createElement(CouponNumberBoard, {
        branding: branding,
        drawData: drawData,
        isPixMix: isPixMix
      });
    case RACING:
      return React.createElement(CouponRacing, {
        isPixMix: isPixMix,
        productId: productId,
        raceData: drawData
      });
    default:
      logger.warn("Unsupported product: ".concat(productId));
      break;
  }
};
const QuickplayModalMain = _ref2 => {
  let {
    branding,
    drawData,
    onRefreshPix,
    isPixMix,
    productSizes
  } = _ref2;
  const {
    productId
  } = drawData;
  const pixHandler = getPixHandler({
    isPixMix
  });
  const {
    systemCost,
    systemType
  } = pixHandler.getProduct(productId);
  const [selectedSystemCost, setSelectedSystemCost] = useState(systemCost);
  const systemPrice = getSystemPrice(selectedSystemCost, systemType, productId);
  const showPricePicker = (productSizes === null || productSizes === void 0 ? void 0 : productSizes.length) > 0;
  const handleOnClick = () => {
    if (isPixMix) {
      const event = {
        category: 'PIX-mixen',
        action: 'Generate row',
        opt_label: getDisplayName(productId)
      };
      svs.components.analytics.trackEvent(event);
    }
    return onRefreshPix({
      updatedSystemCost: selectedSystemCost,
      shouldGenerateNewPix: true
    });
  };
  return React.createElement("div", {
    className: "quickplay-modal-main elevation-400"
  }, React.createElement("div", {
    className: "padding-2 no-text-selection"
  }, Boolean(showPricePicker) && React.createElement(React.Fragment, null, React.createElement("p", {
    className: "align-center price-picker-header margin-bottom-0"
  }, "V\xE4lj belopp"), React.createElement(NumberSelector, {
    className: "quickplay-modal-number-selector",
    isStepOnly: true,
    maxValue: productSizes[productSizes.length - 1],
    minValue: productSizes[0],
    onValueChange: value => {
      setSelectedSystemCost(productSizes[value]);
      onRefreshPix({
        updatedSystemCost: productSizes[value]
      });
    },
    possibleValues: productSizes,
    size: 600,
    suffix: " kr",
    value: productSizes.indexOf(selectedSystemCost)
  })), Boolean(!showPricePicker) && React.createElement("h2", {
    className: "f-900 f-center notranslate margin-bottom-0"
  }, "".concat(formatCurrency(systemPrice), " kr"))), renderCoupon({
    branding,
    drawData,
    productId,
    isPixMix
  }), React.createElement("div", {
    className: "padding-2"
  }, React.createElement(Button, {
    block: true,
    inverted: productId !== MALTIPSET,
    onClick: handleOnClick,
    size: 300,
    transparent: true
  }, React.createElement(Icon, {
    className: "margin-right-1",
    icon: "refresh-pix",
    size: 300
  }), "Generera ny PIX!")));
};
setGlobal('svs.components.sport.quickplayModal.QuickplayModalMain', QuickplayModalMain);

 })(window);